// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mcName[data-v-0fede030]{text-overflow:ellipsis}.text__mc-name[data-v-0fede030]{font-weight:500;font-size:20px;line-height:24px}.text__mc-description[data-v-0fede030]{font-weight:400;font-size:16px;color:rgba(7,9,25,.5)}@media (max-width:765px){.text-mc-name[data-v-0fede030]{font-size:14px}.text-mc-description[data-v-0fede030]{font-size:12px}.text-mc-type[data-v-0fede030]{display:none}}", ""]);
// Exports
module.exports = exports;
